import { render, staticRenderFns } from "./create-documento.vue?vue&type=template&id=3408a205"
import script from "./create-documento.vue?vue&type=script&lang=ts"
export * from "./create-documento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports